import React from "react";
import Products from "../Products/Products";
import "./AllProducts.scss";

const AllProducts = () => {
  return <Products />;
};

export default AllProducts;
